import { EN_US } from 'constants/LocaleCodes';

export default (fallback = EN_US) => {
  const language = navigator.languages
    ? navigator.languages[0]
    : navigator.language || navigator.userLanguage;

  return language || fallback;
};
